import React from 'react';
import PropTypes from 'prop-types';
import Menu from 'antd/lib/menu';

import { StyledPopup, StyledMenuItem } from './style';


const ContextMenu = ({
  latitude,
  longitude,
  buttonText,
  onMenuItemClick,
  handleOnCloseClick,
}) => (
  <StyledPopup
    closeOnClick={false}
    tipSize={0}
    anchor="top-left"
    offsetLeft={5}
    closeButton={false}
    latitude={latitude}
    longitude={longitude}
    onClose={handleOnCloseClick}
  >
    <Menu>
      <StyledMenuItem onClick={onMenuItemClick}>
        <span className="context-menu-item">{buttonText}</span>
      </StyledMenuItem>
    </Menu>
  </StyledPopup>
);

ContextMenu.propTypes = {
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  buttonText: PropTypes.string,
  onMenuItemClick: PropTypes.func,
  handleOnCloseClick: PropTypes.func,
};

export default ContextMenu;
